import React from 'react';
import {getOptionsForAttr} from './coderefs';
import {errorSink} from '../ErrorSink';
import {PortalSelect, PortalSelectOption} from "../PortalSelect";

export function CodeRefEnum({attr, ...props}) {
  const data = getOptionsForAttr(attr);

  if (!data || !data.list) {
    return errorSink('no coderefs found for attribute' + JSON.stringify(attr));
  }

  return <PortalSelect {...props}>
      {
        data.list.map(({value, name}, index) => <PortalSelectOption value={value} key={index}>
          {name}
        </PortalSelectOption>)
      }
    </PortalSelect>;
}

